import { apiService } from "@/lib/api";

const BASE_URL = "/api/v2/calendar-type";

export const CalendarTypeService = {
  async list(params = {}) {
    const response = await apiService.getSecure(`${BASE_URL}/list`, {
      params: {
        ...(params.page !== undefined ? { page: params.page } : {}),
        ...(params.per_page !== undefined ? { per_page: params.per_page } : {}),
        ...(params.search !== undefined ? { search: params.search } : {}),
        ...(params.sort_by !== undefined ? { sort_by: params.sort_by } : {}),
        ...(params.sort_order !== undefined ? { sort_order: params.sort_order } : {}),
      },
    });
    return response.data;
  },

  // Every page of /calendar-type/list, name-sorted. A tenant can add one
  // calendar per country and the endpoint caps per_page at 100, so a single
  // call is not enough. `has_next` is the wire name — PaginationData has no
  // camelCase alias generator, so it stays snake_case even here.
  async listAll() {
    const perPage = 100;
    const all = [];
    for (let page = 1; page <= 50; page += 1) {
      const body = await CalendarTypeService.list({
        page,
        per_page: perPage,
        sort_by: "name",
        sort_order: "asc",
      });
      const items = Array.isArray(body?.data) ? body.data : [];
      all.push(...items);
      const hasNext = body?.pagination?.has_next ?? false;
      if (!hasNext || items.length === 0) break;
    }
    return all;
  },

  async getById(calendarTypeId) {
    const response = await apiService.getSecure(`${BASE_URL}/get/${calendarTypeId}`);
    return response.data;
  },

  async create(payload) {
    const response = await apiService.postSecure(`${BASE_URL}/create`, payload);
    return response.data;
  },

  async update(calendarTypeId, payload) {
    const response = await apiService.patch(`${BASE_URL}/update/${calendarTypeId}`, payload);
    return response.data;
  },
};

export default CalendarTypeService;
